var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "d-flex align-center justify-center cursor-pointer bg-gray-0",
      style: _vm.size
        ? {
            width: `${_vm.size}px`,
            height: `${_vm.size}px`,
          }
        : undefined,
      attrs: { "data-qa": "share_btn" },
      on: { click: _setup.handleShareClick },
    },
    [
      _c("span", {
        staticClass: "ui-icon-share-circle ui-icon-fz-medium text-info--text",
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }